import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { adminLogin } from "../redux/slices/adminSlice";
import Swal from "sweetalert2";


const SignInLayer = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // 🔥 admin state
  const { user, loading, error } = useSelector((state) => state.admin);

  //
  // ❌ ERROR HANDLING (SweetAlert)
  //
  useEffect(() => {
    if (error) {
      Swal.fire({
        icon: "error",
        title: "Login Failed",
        text: error,
        confirmButtonColor: "#f41b3b"
      });
    }
  }, [error]);

  //
  // ✅ SUCCESS LOGIN
  //
  useEffect(() => {
    if (user) {
      // 🔥 role check
      if (user.role?.toLowerCase() === "admin") {
        Swal.fire({
          icon: "success",
          title: "Login Successful 🎉",
          text: "Welcome Admin!",
          timer: 1500,
          showConfirmButton: false
        });

        navigate("/"); // dashboard ya home
      } else {
        Swal.fire({
          icon: "error",
          title: "Access Denied",
          text: "Only Admins can login here",
          confirmButtonColor: "#f41b3b"
        });
      }
    }
  }, [user, navigate]);

  //
  // 🚀 SUBMIT
  //
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!email || !password) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please enter email and password",
        confirmButtonColor: "#f41b3b"
      });
      return;
    }

    dispatch(adminLogin({ email, password }));
  };

  return (

    <section className="auth bg-base d-flex flex-wrap justify-content-center">
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          
          {/* Header */}
          <div className="text-center">
            <Link to="/" className="mb-10 max-w-290-px">
              <img
                src="assets/images/logo.png"
                alt=""
                width={"100%"}
                height={100}
              />
            </Link>

            <h5 className="mb-2">Sign In to your Account</h5>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome! Please enter your details
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            
            {/* Email */}
            <div className="icon-field mb-16">
              <span className="icon top-50 translate-middle-y">
                <Icon icon="mage:email" />
              </span>
              <input
                type="email"
                className="form-control h-56-px bg-neutral-50 radius-12"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Password */}
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type="password"
                  className="form-control h-56-px bg-neutral-50 radius-12"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
            </div>

            {/* Button */}
            <button
              type="submit"
              className="btn text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              style={{ backgroundColor: "rgb(1 54 97)", color: "#fff" }}
              disabled={loading}
            >
              {loading ? "Signing In..." : "Sign In"}
            </button>

          </form>
        </div>
      </div>
    </section>
  );
};

export default SignInLayer;